export default __webpack_public_path__ + "static/media/customzones.5a25b535.gif";